import { render, staticRenderFns } from "./SiteDisplay.vue?vue&type=template&id=2b695b14&scoped=true&"
import script from "./SiteDisplay.vue?vue&type=script&lang=js&"
export * from "./SiteDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SiteDisplay.vue?vue&type=style&index=0&id=2b695b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b695b14",
  null
  
)

export default component.exports